import { render, staticRenderFns } from "./StepSidebar.vue?vue&type=template&id=5905c08e"
import script from "./StepSidebar.vue?vue&type=script&lang=js"
export * from "./StepSidebar.vue?vue&type=script&lang=js"
import style0 from "./StepSidebar.vue?vue&type=style&index=0&id=5905c08e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports